import { memo } from 'react';
import Avatar from '../Avatar.jsx';
import IconHighlight from '../IconHighlight.jsx';
import {
  MENU_ITEM_AVATAR_DEFAULT_CLASS,
  MENU_ITEM_AVATAR_SIZE,
  MENU_ITEM_ICON_SIZE,
} from './menuTokens.js';
import { joinClasses } from './menu.utils.js';

/**
 * @param {object} props
 * @param {'medium' | 'small'} props.sizeKey
 * @param {boolean} props.isDisabled
 * @param {string} props.label
 * @param {{ src?: string, initials?: string, alt?: string, className?: string } | null} props.avatarConfig
 * @param {import('lucide-react').LucideIcon | null} props.highlightIcon
 * @param {import('lucide-react').LucideIcon | null} props.icon
 */
function MenuItemLeading({
  sizeKey,
  isDisabled,
  label,
  avatarConfig,
  highlightIcon: HighlightIcon,
  icon: Icon,
}) {
  if (avatarConfig) {
    return (
      <Avatar
        size={MENU_ITEM_AVATAR_SIZE[sizeKey]}
        src={avatarConfig.src}
        initials={avatarConfig.initials}
        alt={avatarConfig.alt ?? label}
        className={joinClasses(
          MENU_ITEM_AVATAR_DEFAULT_CLASS,
          avatarConfig.className,
          isDisabled && 'opacity-60',
        )}
      />
    );
  }

  if (HighlightIcon) {
    return (
      <IconHighlight
        icon={HighlightIcon}
        bgColor="Primary"
        iconColor="PrimaryAlt"
        size="small"
        className={joinClasses(
          '!h-6 !w-6 !min-h-6 !min-w-6 p-2',
          isDisabled && 'opacity-60',
        )}
      />
    );
  }

  if (Icon) {
    return (
      <Icon
        size={MENU_ITEM_ICON_SIZE[sizeKey]}
        className={joinClasses(
          'shrink-0',
          isDisabled ? 'text-content-muted' : 'text-content',
        )}
        aria-hidden
      />
    );
  }

  return null;
}

export default memo(MenuItemLeading);
